import {
  IPropertyOptionByType,
  IPropertyOptionsWithType
} from "@kuika/kuika-cl-model/src/models/property-type-options";
import _ from "lodash";
import * as React from "react";
import KuikaSelectbox, { KuikaSelectboxOption } from "../../../ui-kit/kuika-selectbox/kuika-selectbox";

export interface IPropertyFormDynamicInputFormatterState {
  selectedTypeOptions?: IPropertyOptionByType[];
}

export interface IPropertyFormDynamicInputFormatterProps {
  allTypeOptions: IPropertyOptionsWithType[];
  selectedTypeOptions?: IPropertyOptionByType[];
  onChange: (value: any) => void;
  changeType: "onBlur" | "onKeyPress";
  updateDebounce: number;
  disabled?: boolean;
}

export class PropertyFormDynamicInputFormatter extends React.PureComponent<
  IPropertyFormDynamicInputFormatterProps,
  IPropertyFormDynamicInputFormatterState
> {
  constructor(props) {
    super(props);
    this.state = { selectedTypeOptions: this.props.selectedTypeOptions };
  }

  componentDidUpdate = (prevProps: IPropertyFormDynamicInputFormatterProps) => {
    if (prevProps === this.props) return;
  };

  waitAndChange = _.debounce((value: string) => this.props.onChange(value), this.props.updateDebounce);

  updateSelectedTypeOptions = (value: string, typeName: string): void => {
    const selectedTypeOptions = _.cloneDeep(this.state.selectedTypeOptions);
    if (selectedTypeOptions) {
      const newSelection = selectedTypeOptions.find((sto) => sto.type === typeName);
      if (newSelection) {
        newSelection.option = value;
      } else
        selectedTypeOptions.push({
          type: typeName,
          option: value
        } as IPropertyOptionByType);
      this.setState({ selectedTypeOptions });
      this.props.onChange(selectedTypeOptions);
    }
  };

  getValue = (typeOption) => {
    const { selectedTypeOptions } = this.state;
    const selected = selectedTypeOptions?.find((sto) => sto.type === typeOption.type);
    return selected?.option || "";
  };

  render() {
    return this.props.allTypeOptions.map((typeOption) => {
      return (
        <div key={typeOption.type} style={{ marginBottom: 10 }}>
          <label className="k_Regular-G1-Left kuika_rightPanelDIName" style={{ marginTop: 8, marginBottom: 6 }}>
            {typeOption.type}
          </label>
          <KuikaSelectbox
            size="sm"
            style={{ width: "100%" }}
            value={this.getValue(typeOption)}
            onChange={(value: string): void => this.updateSelectedTypeOptions(value, typeOption.type)}
            options={typeOption.options!.map((o: string, idx: number): KuikaSelectboxOption => ({
              key: `pt_${idx}`,
              value: o,
              label: o
            }))}
          />
        </div>
      );
    });
  }
}
